import { cqrs } from '@faro/http-clients';
import { ClassType, toClassType } from '@faro/study-designer-model';

export const classTypeClient = cqrs<ClassType>(
    '/api/study-designer/enumerated-values/class-types',
    toClassType
).listableEntityClient();
